import React, { Component } from 'react'
import StudentOrganizationProfileSection from '../components/student_organization_profile/StudentOrganizationProfileSection';
class StudentWiseResult extends Component {
    render() {
        // Route: /student/studentwise-result/:student_user_exam_id. The segment
        // may carry the legacy ":" prefix ("/:123"), so strip it before parsing.
        const raw = String(this.props.match.params.student_user_exam_id || "").replace(/^:/, "");
        const student_user_exam_id = parseInt(raw, 10) || 0;

        return (
            
               <StudentOrganizationProfileSection
                    hislocationData={{ student_user_exam_id }} />

            
        )
    }
}

export default StudentWiseResult
